<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat>
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">Сегодня</v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">{{ $refs.calendar.title }}</v-toolbar-title>
          <v-spacer></v-spacer>

        </v-toolbar>
      </v-sheet>
      <v-sheet>
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          event-end="end_at"
          event-start="start_at"
          :events="entities"
          :event-color="getEventColor"
          @click:event="showEvent"
          @change="updateRange"
        >
          <template #event="{event}">
            <div class="event-row">{{event.name}}</div>
          </template>
        </v-calendar>
        <VDialog v-model="modal" v-if="modal" class="entity-modal">
          <ProjectDetail class="modal-entity" use-prop :id="selectedProject.id.toString()" />
        </VDialog>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import colorHash from 'color-hash';
export default {
  components: {
    ProjectDetail: () => import('@/views/Project/ProjectDetail.vue'),
  },
  data: () => ({
    focus: '',
    type: 'month',
    typeToLabel: {
      month: 'Месяц',
      week: 'Неделя',
      day: 'День',
    },
    selectedProject: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    hash: null,
    modal: false,
  }),
  async mounted() {
    this.hash = new colorHash();
    await this.getEntities();
    this.$refs.calendar.checkChange();
  },
  methods: {
    ...mapActions('projectCalendar', ['getEntities']),
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getEventColor(project) {
      return this.hash ? this.hash.hex(project.id) : '#00bcd4';
    },
    setToday() {
      this.focus = '';
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      this.selectedProject = event;
      this.modal = true;
      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];
      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
    },
  },
  watch:{
    async focus(){
      await this.getEntities(this.focus)
    }
  },
  computed: {
    ...mapState('projectCalendar', ['entities']),
  },
};
</script>
<style lang="scss">
.event-row {
  padding-left: 8px;
}
</style>